const EarlyGothicEra = {
  id: '13',
  name: 'Early Gothic Era'
};

export default EarlyGothicEra;
